import { useEffect, useRef } from 'react'
import { doc, onSnapshot } from 'firebase/firestore'
import { fireStore } from '@/configs/firebaseConfig'
import { getDeviceId } from '@/utils/helpers/device'
import { queryClient } from '@/configs/tanstack'
import { QUERY_KEY_DETAIL_APPOINTMENT } from '../appointment/useGetAppointmentDetail'
import { QUERY_KEY_APPOINTMENT_ITEMS } from '../appointment/useGetAppointmentItems'

interface TransactionSignal {
  updatedAt: string
  deviceId: string
  effectedTransactionId: string
  transactionDate: string
  action: string
}

const deviceId = getDeviceId()

export const useTransactionBranchSignal = (branchId: string | null) => {
  const isInitialLoad = useRef(true)

  useEffect(() => {
    isInitialLoad.current = true
    if (!branchId) return

    const docRef = doc(fireStore, 'transaction-branch-signals', branchId)

    const unsubscribe = onSnapshot(
      docRef,
      (snapshot) => {
        // ⛔ skip initial snapshot
        if (isInitialLoad.current) {
          isInitialLoad.current = false
          return
        }

        const payload = snapshot.data() as TransactionSignal
        if (deviceId !== payload?.deviceId) {
          // remove transaction cache
          queryClient.invalidateQueries({
            queryKey: [
              QUERY_KEY_DETAIL_APPOINTMENT,
              payload.effectedTransactionId,
              branchId,
            ],
          })
          // update calendar data
          queryClient.invalidateQueries({
            queryKey: [QUERY_KEY_APPOINTMENT_ITEMS],
          })
        }
      },
      (err) => {
        console.error(err)
      },
    )

    return () => {
      unsubscribe()
    }
  }, [branchId])
}
